import React, { useContext } from 'react'
import { useLocation } from 'react-router-dom'
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import PopupMerge from './error/popup';
import Typography from '@mui/material/Typography';
import './merge-profile.css';
import PopUpMsg from './popUpMsg'
import { Link } from "react-router-dom";
import { CardActions, Tooltip, IconButton, Stack } from '@mui/material';
import { useState } from 'react';
import vendorInfo from '../../config/MergeSourceScope.json'
import popUpMessages from '../../config/popUpMsg.json';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from "react-router-dom";
import ProfileIcon from '../shared/ProfileIcon';
import { DirectionContext } from '../../context/DirectionProvider';
import CONSTANT from '../../Constant/Constant';


const Merge = () => {
  const location = useLocation();
  const history = useHistory();
  const [popMsg, setPopMsg] = useState(popUpMessages.mergeProfile)
  //const [mergeConfigData, setMergeCofigData] = useState(mergeConfig)
  const [loserProfile, setLoserProfile] = useState([])
  const [winnerProfile, setWinnerProfile] = useState([])
  const [profiles, setProfile] = useState(location.state.mergeData)
  const [showLoserProfile, setShowLoserProfile] = useState(false)
  const [showLoserSelect, setShowLoserSelect] = useState(false)
  const [showWinnerProfile, setShowWinnerProfile] = useState(false)
  const [modalData, setModalData] = useState({ flag: false, success: false, title: '', message: '' })
  const [showPopup, setShowPopup] = useState(false)
  const [showDialog, setShowDialog] = useState(false)
  const [loserRecord, setLoserRecord] = useState([])
  const [winnerRecord, setWinnerRecord] = useState([])
  const [selectIndex, setSelectIndex] = useState()
  const [selectedItem, setSelectedItem] = useState([])
  const [loserSelectedProfile, setLoserSelectedProfile] = useState([])
  const [popUpMessage, setPopUpMessage] = useState({ heading: '', message: '' })
  const [vendorList, setVendorList] = useState(vendorInfo.excludeVendorSources)
  var loserData = []
  var winnerData = []

  const direction = useContext(DirectionContext);
  


  //winner profile select
  const profileSelect = (data) => {

    setSelectIndex(data._id)
    setLoserProfile(profiles.filter((arr) => arr._id !== data._id))
    setWinnerProfile(profiles.filter((arr) => arr._id === data._id))
    setLoserSelectedProfile(profiles.filter((arr) => arr._id !== data._id))
  }

  //loser profile select
  const loserSelected = (data) => {

    if (loserSelectedProfile.some((arr) => arr._id === data._id)) {
      setLoserSelectedProfile(loserSelectedProfile.filter((value) => value._id !== data._id))

    }
    else {

      setLoserSelectedProfile([...loserSelectedProfile, data])
    }

    if (selectedItem.includes(data._id)) {

      setSelectedItem(selectedItem.filter((value) => value !== data._id))
    }

    else {

      setSelectedItem([...selectedItem, data._id])
    }

  }

  //After selecting winner profile
  const nextButton = (e) => {

    if (winnerProfile.length >= 1) {
      setShowLoserSelect(true)
      setShowWinnerProfile(true)
    }
    else {
      setPopUpMessage({ heading: popMsg[0].noWinnerSelected.heading, message: popMsg[0].noWinnerSelected.description, onOk: 'Confirm' })
      setShowPopup(true)
    }

  }

  const goBack = () => {
    history.goBack()

  }

  const checkSource = (sources) => {
    let lillySource = [];
    if ((sources === undefined) || (Object.keys(sources).length === 0)) {                     
        return sources;
    } else if (typeof(sources) == 'string'){
        if(CONSTANT.ALL_SOURCES.includes(sources)){
            return CONSTANT.LILLY_SOURCES_VALUES[sources]
        }
    } else {       
        sources.forEach((source) => {                
            if (CONSTANT.ALL_SOURCES.includes(source.value)) {                                   
                lillySource.push(source.value);                    
            }                
        })
    }        
    if (lillySource.length === 0) {     
        return sources;
    }else if(lillySource.length == 1){           
            return [{ value: CONSTANT.LILLY_SOURCES_VALUES[lillySource[0]] }]
        } else{                          
            if(lillySource.every((res)=>  CONSTANT.LILLY_SOURCES_FOR_EDIT_PROFILE.includes(res))){
                return [{value: CONSTANT.LILLY_SOURCES_VALUES['MNGD-AFF']}]
            } else if(lillySource.every((res)=>  CONSTANT.VENDOR_SOURCE.includes(res) )){                
                return null
            } else if (lillySource.includes(CONSTANT.VENDOR_SOURCE[0])) {
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.VENDOR_SOURCE[0]]}]
            } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[0])) {
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[0]] }]
            } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[1])) {
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[1]] }]
            } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[2])) {
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[2]] }]
            } else if (lillySource.includes(CONSTANT.LILLY_SOURCES[3])) {
                return [{ value: CONSTANT.LILLY_SOURCES_VALUES[CONSTANT.LILLY_SOURCES[3]] }]
            }
        }
  }

  //merge request
  const mergeRequest = () => {

    if (winnerProfile.length >= 1) {

      setShowLoserProfile(true)
      loserProfile.map((res) => loserData.push({ 'type': res._source.type.split('/')[2], '_id': res._id, '_source': { 'primary_HCPReferenceId': res._source.primary_HCPReferenceId,'primary_HCOReferenceId': res._source.primary_HCOReferenceId, 'label': res._source.label, 'CountryCode': res._source.CountryCode, 'ActiveFlag': res._source.ActiveFlag, 'Source': checkSource(res._source.Source), 'secondaryLabel': res._source.secondaryLabel } }))
      winnerProfile.map((res) => winnerData.push({ 'type': res._source.type.split('/')[2], '_id': res._id, '_source': { 'primary_HCPReferenceId': res._source.primary_HCPReferenceId, 'primary_HCOReferenceId': res._source.primary_HCOReferenceId, 'label': res._source.label, 'CountryCode': res._source.CountryCode, 'ActiveFlag': res._source.ActiveFlag, 'Source': checkSource(res._source.Source), 'secondaryLabel': res._source.secondaryLabel } }))
      // setLoserData(...{'entity':loserProfile._id})
      setLoserRecord(loserData)
      setWinnerRecord(winnerData)
      setModalData({ flag: true, success: true, title: 'Submit Request', message: 'Comments *' })
      setShowDialog(true)

    }



  }

  //onclicking ok button in popup
  const onOK = () => {

    setModalData({ flag: false, success: false, title: '', message: '' })
    setShowPopup(false)
  }

  const onCancel = () => {

    setModalData({ flag: false, success: false, title: '', message: '' })
    setShowDialog(true)
  }


  //to view the selection of winner and loser profiles for merge
  const preView = () => {

    if (loserSelectedProfile.length >= 1) {
      if (winnerProfile.every((e) => e._source.Source.some((arr) => !(vendorList.includes(arr.value)))) && loserProfile.every((e) => e._source.Source.some((arr) => vendorList.includes(arr.value)))) {

        setPopUpMessage({ heading: popMsg[0].wrongSourceProfileSelected.heading, message: popMsg[0].wrongSourceProfileSelected.description, onOk: 'Confirm' })
        setShowPopup(true)

      }
      // check if winner profile is active and loser profile is inactive else show error popup can cancel selection
      else if (winnerProfile.every((e) => e._source.ActiveFlag[0].value === 'N') && loserSelectedProfile.every((e) => e._source.ActiveFlag[0].value === 'Y')) {
        setPopUpMessage({ heading: popMsg[0].activeInactiveProfile.heading, message: popMsg[0].activeInactiveProfile.description, onOk: 'Confirm' })
        setShowPopup(true)
      }
      else {

        setLoserProfile(loserSelectedProfile)
        setShowLoserSelect(false)
        setShowLoserProfile(true)
      }
    }
    else {
      setPopUpMessage({ heading: popMsg[0].noLoserSelected.heading, message: popMsg[0].noLoserSelected.description, onOk: 'Confirm' })
      setShowPopup(true)
    }
  }

  // reset all the selection of profile
  const clearAll = () => {

    setShowLoserProfile(false)
    setShowWinnerProfile(false)
    setShowLoserSelect(false)
    setLoserProfile([])
    setWinnerProfile([])
    setSelectIndex()
    setSelectedItem([])
    setLoserSelectedProfile([])
    setPopUpMessage({ heading: '', message: '' })

  }


  const noAction = () => {

  }

  return (

    <div className="extra-margin-top-less container w-80 body-height min-width">

     <Stack direction={'row'} justifyContent={'flex-start'}>
        <Tooltip disableFocusListener title="Back" id='tltipStrictSearchChckbx'>
        <IconButton aria-label="delete" onClick={goBack} className="text-danger float-end" color="secondary">
          <ArrowBackIcon sx={{transform: direction==='rtl'?'rotate(180deg)':''}} />
        </IconButton>
        </Tooltip>
     </Stack>

      <div className="row">


        {!showWinnerProfile && <h4 id="mergeheading">Select Winner Profile</h4>}
        {showWinnerProfile && <h4 id="mergeheading"> Winner Profile</h4>}
        {
          (showWinnerProfile ? winnerProfile : profiles).map((value, index) => {

            return (<React.Fragment key={index}>
              <div className="col-md-6 mt-3 " >
                <Card style={{ display: 'flex', cursor: 'pointer', minHeight: '150px', height: "100%", maxHeight: 'auto', boxShadow: '1px 1px 5px grey' }} className={selectIndex === value._id ? 'focus-only' : ''} onClick={!showWinnerProfile ? ((event) => profileSelect(value)) : (() => noAction())}>
                  <CardActions>
                    <ProfileIcon
                        sx={{width: '110px', height:'110px'}}
                        iconSX={{fontSize:'4.6rem'}}
                        type={value._source?.type?.split('/')[2]}
                      />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <CardContent sx={{ flex: '1 0 auto', fontSize: '15px' }}>

                        
                        <Typography component="div" variant="p" className="merge-text">
                          {value?._source && value?._source?.label ?<> <span> Name: </span><span className='_wg-exclude'>{value._source.label}</span> </> : ''}
                        </Typography>

                        <Typography variant="p" color="text.secondary" component="div" className="merge-text">
                          {value?._id ? <> <span>Id: </span> <span className='_wg-exclude'>{value._id} </span> </> : ''}
                        </Typography>

                        <Tooltip disableFocusListener title={<span><span className="merge-text">Address: </span> <span className='_wg-exclude'>{value._source.secondaryLabel}</span></span>}>
                          <Typography component="div" variant="p" color="text.secondary" className="merge-text cardtext">
                            {value?._source?.secondaryLabel ? <> <span> Address: </span> <span className='_wg-exclude'>{value._source.secondaryLabel}</span></> : ''}
                          </Typography>
                        </Tooltip>

                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.ActiveFlag ? <> <span >Active Flag: </span> <span className='_wg-exclude'>{value._source.ActiveFlag[0].value}</span></> : ''}
                        </Typography>


                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.Source ? <> <span >Source: </span> <span className='_wg-exclude'>{value._source.Source[0].value}</span> </> : ''}
                        </Typography>

                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.primary_HCOUniqueId ? <> <span dir={direction} className='_wg-exclude'> HCO Unique Id: </span> <span dir={direction} className='_wg-exclude'>{value._source.primary_HCOUniqueId[0].value} </span> </> : ''}
                        </Typography>

                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.primary_HCPUniqueId ? <> <span dir={direction} className='_wg-exclude'> HCP Unique Id: </span><span dir={direction} className='_wg-exclude'>{value._source.primary_HCPUniqueId[0].value} </span> </> : ''}
                        </Typography>

                        <Typography variant="p" color="text.secondary" component="div" className="merge-text" >
                          {value?._id && value._source?.type ?
                            <Link to={'/details/' + value._id + '/' + value._source?.type.split('/')[2]} target="_blank" className=" text-decoration-none">

                              More details
                            </Link>
                            : ''}
                        </Typography>
                      </CardContent>
                    </Box>
                  </CardActions>
                </Card>
              </div>
            </React.Fragment>
            )
          })
        }
      </div>

      {!showWinnerProfile &&

        <button className="btn btn-secondry mergeButton d-flex justify-content-center mt-5" style={{ width: '100px' }} onClick={(event) => nextButton(event)} id="mergeButton"  >
          Next
        </button>
      }

      <div className="row mt-5">

        {showLoserSelect && <h4 id="mergeheading" >Loser Profile</h4>}
        {showLoserProfile && <h4 id="mergeheading">Loser Profile</h4>}

        {(showLoserSelect || showLoserProfile) &&
          loserProfile.map((value, index) => {

            return (<React.Fragment key={index}>
              <div className="col-md-6 mt-3">
                <Card sx={{ display: 'flex', cursor: 'pointer', minHeight: '150px', height: "100%", maxHeight: 'auto', boxShadow: '1px 1px 5px grey' }} className={selectedItem.includes(value._id) ? 'loserborder' : 'loserborder'}>
                  <CardActions>
                    <ProfileIcon
                      sx={{width: 110, height: 110}}
                      iconSX={{fontSize:'4.6rem'}}
                      type={value._source?.type?.split('/')[2]}
                    />

                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <CardContent sx={{ flex: '1 0 auto', fontSize: '15px' }}>

                         <Typography component="div" variant="p" className="merge-text">
                          {value?._source && value?._source?.label ?<> <span> Name: </span><span className='_wg-exclude'>{value._source.label}</span> </> : ''}
                        </Typography>

                        <Typography variant="p" color="text.secondary" component="div" className="merge-text">
                          {value?._id ? <> <span >Id: </span> <span className='_wg-exclude'>{value._id} </span> </> : ''}
                        </Typography>

                        <Tooltip disableFocusListener title={<span><span className="merge-text">Address: </span> <span className='_wg-exclude'>{value._source.secondaryLabel}</span></span>}>
                          <Typography component="div" variant="p" color="text.secondary" className="merge-text cardtext">
                            {value?._source?.secondaryLabel ? <> <span > Address: </span> <span className='_wg-exclude'>{value._source.secondaryLabel}</span></> : ''}
                          </Typography>
                        </Tooltip>

                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.ActiveFlag ? <> <span>Active Flag: </span> <span className='_wg-exclude'>{value._source.ActiveFlag[0].value}</span></> : ''}
                        </Typography>


                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.Source ? <> <span >Source: </span> <span className='_wg-exclude'>{value._source.Source[0].value}</span> </> : ''}
                        </Typography>

                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.primary_HCOUniqueId ? <> <span className='_wg-exclude' dir={direction}> HCO Unique Id: </span> <span dir={direction}className='_wg-exclude'>{value._source.primary_HCOUniqueId[0].value} </span> </> : ''}
                        </Typography>

                        <Typography component="div" variant="p" color="text.secondary" className="merge-text">
                          {value?._source?.primary_HCPUniqueId ? <> <span className='_wg-exclude' dir={direction}> HCP Unique Id: </span><span dir={direction} className='_wg-exclude'>{value._source.primary_HCPUniqueId[0].value} </span> </> : ''}
                        </Typography>

                        <Typography variant="p" color="text.secondary" component="div" className="merge-text">
                          {value?._id && value._source?.type ?
                            <Link to={'/details/' + value._id + '/' + value._source?.type.split('/')[2]} target="_blank" className=" text-decoration-none">
                              More details
                            </Link>
                            : ''}
                        </Typography>
                      </CardContent>
                    </Box>
                  </CardActions>
                </Card>
              </div>
            </React.Fragment>
            )
          })
        }
      </div>

      {showLoserSelect &&

        <div className="MuiAccordionActions-root d-flex justify-content-center mt-4 MuiAccordionActions-spacing">
          <div className="d-flex justify-content-center mt-4 mb-3">
            <button className="btn btn-secondry border clearall _wg-dynamic-text" onClick={() => clearAll()}>
              Clear All
            </button>

            <button className="mergeButton btn btn-secondry border request nextButton _wg-dynamic-text" onClick={() => { preView() }}  >
              Preview
            </button>

          </div>
        </div>
      }

      {showLoserProfile &&
        <div className="MuiAccordionActions-root d-flex justify-content-center mt-4 mb-3 MuiAccordionActions-spacing">
          <div className="d-flex justify-content-center mt-4 mb-3">
            <button className="btn btn-secondry border clearall _wg-dynamic-text" onClick={() => clearAll()}>
              CLEAR All
            </button>

            <button className="mergeButton btn btn-secondry border request nextButton _wg-dynamic-text" onClick={() => { mergeRequest() }}>
              Request Merge
            </button>

          </div>
        </div>

      }

      {showPopup &&
        <PopUpMsg
          popUpMessage={popUpMessage}
          onOK={() => onOK()}
        />
      }

      {
        showDialog && modalData && modalData.flag && loserData && winnerData &&
        <PopupMerge
          detail={{ winner: winnerRecord, losers: loserRecord }}
          open={modalData.flag}
          success={modalData.success}
          message={modalData.message}
          title={modalData.title}
          onCancel={() => onCancel()}
        />
      }
    </div>

  )
}
export default Merge;